<template>
  <v-card>
    <div style="position: relative">
      <h1 class="text-pagename text-xs-center">Rider management</h1>

      <div style="position: absolute; top: 0px; right: 0px">
        <v-btn
          icon
          :to="'/weserve_admin_login/control/phuket/rider/rider-delete'"
          ><v-icon color="red">mdi-history</v-icon></v-btn
        >
      </div>
    </div>
    <riderVeiws :riders="riders"></riderVeiws>
  </v-card>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import riderVeiws from "@/components/back-office/Rider/RiderListViews.vue";
export default {
  data: function () {
    return {};
  },
  components: {
    riderVeiws,
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },
      {
        text: "Rider",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/rider/riderinhouse",
        // href:
        //    "/weserve_admin_login/control/" +
        //   this.$route.params.province +
        //   "/rider/riderdashboard"
      },
      {
        text: "Rider management",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
  created() {
    // this.$store.dispatch('fetchRiderListBack/getRiderList')
  },
  computed: {
    ...mapState({
      riders: (state) => state.fetchRiderListBack.riders_inhouse,
    }),
  },
};
</script>
